export const calculeteTotalAgreedValue = (
  agreedHourlyRate: number,
  exceptionalDuration: number
) => {
  return Math.round(agreedHourlyRate * exceptionalDuration)
}

// Custo Base = ( Duração Excepcional ÷ Duração Base ) × Valor Hora Base
export const calculeteBaseCost = (
  baseDuration: number,
  exceptionalDuration: number,
  baseValue: number
) => {
  if (baseDuration > 0) {
    return (exceptionalDuration / baseDuration) * baseValue
  }
  return 0
}

// Custo Excepcional = (Duração Base ÷ Duração Excepcional) × Valor Hora Excepcional × (1 + Taxa)
export const calculateExceptionalCost = (
  exceptionalDuration: number,
  baseDuration: number,
  agreedHourlyRate: number,
  tax: number
) => {
  if (exceptionalDuration > 0) {
    return (baseDuration / exceptionalDuration) * agreedHourlyRate * (1 + tax)
  }
  return 0
}

// Prejuízo Previsto = (Custo Excepcional - Custo Base) * Duração Excepcional
export const calculatePredictedResult = (
  exceptionalCost: number,
  baseCost: number,
  exceptionalDuration: number
) => {
  const hourlyDifference = exceptionalCost - baseCost
  return Math.round(hourlyDifference * exceptionalDuration)
}
